import { postRequest, getRequest } from 'utils/http'

export const getSurveyDetails = token => {
  return getRequest(`/users/get-first-name?token=${token}`)
}

export const postSurvey = payload => {
  return postRequest(`/stakeholders/mini-survey`, payload)
}
